import {format} from 'd3-format'

const d3formatMoney = format(',.2f')
const d3formatPercent = format(".0%")
const d3formatNumber = format(',.0f')

 class NumberUtils {

 private static dctFormatter: {[sFormat:string]: any} = {}


  static formatMoney(aValue: number): string {
     return d3formatMoney(aValue)
  }

  static formatPercent(aValue: number): string {
   return d3formatPercent(aValue)
  }

  static format(aValue: number): string {
   return d3formatNumber(aValue)
  }


  static d3format(d3format: string, aValue: number): string {

      if(!(d3format in NumberUtils.dctFormatter)){
        NumberUtils.dctFormatter[d3format] = format(d3format)
      }

      let formatter = NumberUtils.dctFormatter[d3format]
      return formatter(aValue)
  }

  static round(aValue: number, decimalPlaces?: number): number {
      const factorOfTen = Math.pow(10, decimalPlaces)
      return Math.round(aValue * factorOfTen) / factorOfTen
  }

}


export {NumberUtils}

